import { useTranslation } from 'react-i18next';
import { useAdvertiserPermissions } from '@anytag/auth';
import { useAllAdvertisersQuery } from '@anytag/graphql';
import { ButtonLink } from '@anytag/shared-atoms';
import { Header, ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { AdvertisersFilter, AdvertisersList, useAccountsFilter } from '@anytag/shared-organisms';

export const AdvertisersPage = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.Advertiser', appHeader: 'appHeader.Advertisers' });
  const { t } = useTranslation();
  const { hideAddAdvertiserBtn } = useAdvertiserPermissions();
  const { page, limit, filter } = useAccountsFilter();
  const { data, previousData, loading } = useAllAdvertisersQuery({
    fetchPolicy: 'network-only',
    variables: getValuableVariables({
      ...filter,
      limit,
      offset: getOffset(page, limit),
      tiktokPlan: filter.tiktokPlan || null,
      analyticsPlan: filter.analyticsPlan || null,
      verifiedStatus: filter.verifiedStatus || null
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.allAdvertisersCount?.totalNumber;

  return (
    <div>
      <Header>
        {!hideAddAdvertiserBtn ? (
          <ButtonLink
            variant="solid"
            to="/advertiser/add"
            className="ml-auto min-w-[140px] capitalize"
            title={t<string>('Button.Add Advertiser')}
            prefixIcon={{ icon: 'plus', size: '10px' }}
          />
        ) : null}
      </Header>
      <ListWithPagination pagination={{ totalRecords }}>
        <AdvertisersFilter />
        <AdvertisersList loading={loading} totalRecords={totalRecords} data={result?.allAdvertisers || []} />
      </ListWithPagination>
    </div>
  );
};
